import React from 'react';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';
import { Button } from '@/components/ui/button';
import type { BuilderAsk } from '@common-components/ai-chat/transcript';
import type { BuilderAskChoice } from './builder-ask';

/**
 * #813 step 4 — "Update the existing agent, or create a new one?" as two buttons under the
 * builder's question, so the choice is the user's click (never a silent duplicate or a silent edit).
 */
export const BuilderAskCard: React.FC<{ ask: BuilderAsk; disabled?: boolean; onChoose: (choice: BuilderAskChoice) => void }> = ({
  ask,
  disabled,
  onChoose,
}) => {
  const { t } = useTranslation(namespace);
  return (
    <div
      className="self-start flex flex-wrap items-center gap-2 rounded-ai-card border border-ai-border bg-ai-surface px-3 py-2.5 max-w-[520px] animate-in fade-in slide-in-from-bottom-1 duration-(--ai-duration-enter) ease-ai"
      data-testid="builder-ask-card"
      data-reason={ask.reason}
    >
      <Button size="sm" variant="ai" disabled={disabled} onClick={() => onChoose('update')} data-testid="builder-ask-update">
        <span dir="auto" style={{ unicodeBidi: 'plaintext' }}>{t('myBridge.builderChat.askUpdate', { name: ask.label })}</span>
      </Button>
      <Button size="sm" variant="ghost" className="rounded-full border border-ai-border text-ai-text" disabled={disabled} onClick={() => onChoose('create_new')} data-testid="builder-ask-create">
        {t('myBridge.builderChat.askCreate')}
      </Button>
    </div>
  );
};
